/**
 * Single place for CRA env vars so webpack DefinePlugin can inline them reliably.
 * Do not read REACT_APP_* via dynamic/indirect access — it may not get replaced.
 */
export const REACT_APP_WEB3FORMS_ACCESS_KEY =
    process.env.REACT_APP_WEB3FORMS_ACCESS_KEY || "";

export const REACT_APP_ENQUIRY_ENDPOINT =
    process.env.REACT_APP_ENQUIRY_ENDPOINT || "";
